// extracted by mini-css-extract-plugin
module.exports = {"phone":"700","tabletportrait":"980","tabletlandscape":"1200","desktop":"1800"};